import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  padding: ${props => props.theme.spacing.sp16} 0 ${props => props.theme.spacing.sp16} 72px;
  justify-content: center;
  background-color: ${props => props.theme.colors.info.default};
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};

  @media screen and (max-width: 800px) {
    margin-left: 0;
  }
`
